import axios from 'axios';
import { API_BASE_URL, API_ENDPOINTS } from '@/config/api.config';

/**
 * Les jeux de critères mis de côté sur les écrans de liste.
 *
 * Un préréglage appartient à un compte et à un écran: l'API ne rend jamais que
 * ceux du compte connecté, et `scope` dit de quel écran il s'agit. Ce sont les
 * critères qui sont enregistrés, pas les résultats — rappeler un préréglage
 * relance la recherche sur les données du jour.
 */
export const SAVED_FILTER_SCOPES = {
  USERS: 'users',
  COMPANIES: 'companies',
  SURVEYS: 'surveys',
  PRO_SURVEYS: 'pro-surveys',
  QUESTIONS: 'questions',
};

export const savedFilterService = {
  async list(scope, searchText) {
    const response = await axios.get(
      `${API_BASE_URL}${API_ENDPOINTS.SAVED_FILTERS.BASE}`,
      { params: { scope, searchText: searchText || undefined } },
    );
    return Array.isArray(response.data) ? response.data : [];
  },

  async create({ scope, name, criteria, isDefault = false }) {
    const response = await axios.post(
      `${API_BASE_URL}${API_ENDPOINTS.SAVED_FILTERS.BASE}`,
      { scope, name, criteria, isDefault },
    );
    return response.data;
  },

  async update(id, payload) {
    const response = await axios.patch(
      `${API_BASE_URL}${API_ENDPOINTS.SAVED_FILTERS.BY_ID(id)}`,
      payload,
    );
    return response.data;
  },

  async remove(id) {
    await axios.delete(
      `${API_BASE_URL}${API_ENDPOINTS.SAVED_FILTERS.BY_ID(id)}`,
    );
  },
};

export default savedFilterService;
